/**
 * Copyright (c) Microsoft. All rights reserved.
 */
import { __decorate } from "tslib";
import { action, observable } from 'mobx';
/**
 * Controls view configurations for the labeler.
 */
export class LabelerConfigStore {
    constructor(initialParams) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
        this.areAnnotationsValid = true;
        this.isRtl = (_a = initialParams === null || initialParams === void 0 ? void 0 : initialParams.isRtl) !== null && _a !== void 0 ? _a : false;
        this.isDisabled = (_b = initialParams === null || initialParams === void 0 ? void 0 : initialParams.isDisabled) !== null && _b !== void 0 ? _b : false;
        this.wordBreak = (_c = initialParams === null || initialParams === void 0 ? void 0 : initialParams.wordBreak) !== null && _c !== void 0 ? _c : 'normal';
        this.tokenizationType = (_d = initialParams === null || initialParams === void 0 ? void 0 : initialParams.tokenizationType) !== null && _d !== void 0 ? _d : 'character';
        this.enableVirtualization = (_e = initialParams === null || initialParams === void 0 ? void 0 : initialParams.enableVirtualization) !== null && _e !== void 0 ? _e : false;
        this.areTooltipsInDarkMode = (_f = initialParams === null || initialParams === void 0 ? void 0 : initialParams.areTooltipsInDarkMode) !== null && _f !== void 0 ? _f : true;
        this.areAnnotationNamesHidden = (_g = initialParams === null || initialParams === void 0 ? void 0 : initialParams.areAnnotationNamesHidden) !== null && _g !== void 0 ? _g : false;
        this.isSelectionDisabled = this.isDisabled ? true : (_h = initialParams === null || initialParams === void 0 ? void 0 : initialParams.isSelectionDisabled) !== null && _h !== void 0 ? _h : false;
        this.areAnnotationsClickable = this.isDisabled ? false : (_j = initialParams === null || initialParams === void 0 ? void 0 : initialParams.areAnnotationsClickable) !== null && _j !== void 0 ? _j : true;
        this.isAnnotationResizingEnabled = this.isDisabled ? false : (_k = initialParams === null || initialParams === void 0 ? void 0 : initialParams.isAnnotationResizingEnabled) !== null && _k !== void 0 ? _k : false;
    }
    setAreAnnotationValid(value) {
        this.areAnnotationsValid = value;
    }
    setIsRtl(value) {
        this.isRtl = value;
    }
    setIsDisabled(value) {
        this.isDisabled = value;
        this.areAnnotationsClickable = !value;
        this.isSelectionDisabled = value;
    }
    setAreAnnotationsClickable(value) {
        if (value) {
            this.isDisabled = false;
        }
        this.areAnnotationsClickable = value;
    }
    setIsSelectionDisabled(value) {
        if (!value) {
            this.isDisabled = false;
        }
        this.isSelectionDisabled = value;
    }
    setEnableVirtualization(value) {
        this.enableVirtualization = value;
    }
    setAreAnnotationNamesHidden(value) {
        this.areAnnotationNamesHidden = value;
    }
    setIsAnnotationResizingEnabled(value) {
        this.isAnnotationResizingEnabled = value;
    }
    setAreTooltipsInDarkMode(value) {
        this.areTooltipsInDarkMode = value;
    }
    updateConfigs(params) {
        var _a, _b, _c, _d, _e, _f, _g, _h;
        this.isRtl = (_a = params.isRtl) !== null && _a !== void 0 ? _a : this.isRtl;
        this.isDisabled = (_b = params.isDisabled) !== null && _b !== void 0 ? _b : this.isDisabled;
        this.enableVirtualization = (_c = params.enableVirtualization) !== null && _c !== void 0 ? _c : this.enableVirtualization;
        this.areTooltipsInDarkMode = (_d = params.areTooltipsInDarkMode) !== null && _d !== void 0 ? _d : this.areTooltipsInDarkMode;
        this.areAnnotationNamesHidden = (_e = params.areAnnotationNamesHidden) !== null && _e !== void 0 ? _e : this.areAnnotationNamesHidden;
        this.isSelectionDisabled = this.isDisabled ? true : (_f = params.isSelectionDisabled) !== null && _f !== void 0 ? _f : this.isSelectionDisabled;
        this.areAnnotationsClickable = this.isDisabled ? false : (_g = params.areAnnotationsClickable) !== null && _g !== void 0 ? _g : this.areAnnotationsClickable;
        this.isAnnotationResizingEnabled = this.isDisabled ? false : (_h = params.isAnnotationResizingEnabled) !== null && _h !== void 0 ? _h : this.isAnnotationResizingEnabled;
    }
}
__decorate([
    observable
], LabelerConfigStore.prototype, "isRtl", void 0);
__decorate([
    observable
], LabelerConfigStore.prototype, "isDisabled", void 0);
__decorate([
    observable
], LabelerConfigStore.prototype, "areAnnotationsValid", void 0);
__decorate([
    observable
], LabelerConfigStore.prototype, "isSelectionDisabled", void 0);
__decorate([
    observable
], LabelerConfigStore.prototype, "enableVirtualization", void 0);
__decorate([
    observable
], LabelerConfigStore.prototype, "areTooltipsInDarkMode", void 0);
__decorate([
    observable
], LabelerConfigStore.prototype, "areAnnotationsClickable", void 0);
__decorate([
    observable
], LabelerConfigStore.prototype, "areAnnotationNamesHidden", void 0);
__decorate([
    observable
], LabelerConfigStore.prototype, "isAnnotationResizingEnabled", void 0);
__decorate([
    observable
], LabelerConfigStore.prototype, "tokenizationType", void 0);
__decorate([
    observable
], LabelerConfigStore.prototype, "wordBreak", void 0);
__decorate([
    action
], LabelerConfigStore.prototype, "setAreAnnotationValid", null);
__decorate([
    action
], LabelerConfigStore.prototype, "setIsRtl", null);
__decorate([
    action
], LabelerConfigStore.prototype, "setIsDisabled", null);
__decorate([
    action
], LabelerConfigStore.prototype, "setAreAnnotationsClickable", null);
__decorate([
    action
], LabelerConfigStore.prototype, "setIsSelectionDisabled", null);
__decorate([
    action
], LabelerConfigStore.prototype, "setEnableVirtualization", null);
__decorate([
    action
], LabelerConfigStore.prototype, "setAreAnnotationNamesHidden", null);
__decorate([
    action
], LabelerConfigStore.prototype, "setIsAnnotationResizingEnabled", null);
__decorate([
    action
], LabelerConfigStore.prototype, "setAreTooltipsInDarkMode", null);
__decorate([
    action
], LabelerConfigStore.prototype, "updateConfigs", null);
